import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'

import { useCertificationsStore } from '../../../Store/hooks/useStore'

import { CertificationDeleteButtonProps } from './interface'

export const CertificationDeleteButton = ({
  disabled,
  data
}: CertificationDeleteButtonProps) => {
  const deleteCertification = useCertificationsStore(
    state => state.deleteCertification
  )
  return disabled ? null : (
    <ConfirmButton
      danger
      message={'确定删除吗？'}
      placement='top'
      onConfirm={() => deleteCertification(data)}
    >
      删除
    </ConfirmButton>
  )
}
